// src/components/ui/ScrollToTop.jsx
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const location = useLocation();
  const prevPathRef = useRef(location.pathname);

  useEffect(() => {
    // 🔒 Solo scrollea si CAMBIÓ realmente la página
    if (prevPathRef.current !== location.pathname) {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
      prevPathRef.current = location.pathname;
    }
  }, [location.pathname]);

  return null;
};

export default ScrollToTop;
